// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__17QTw","col":"styles_col__1MW_E"};